/**
 * -------------------------------------------------------
 * NOTE: This is a generated file, do not manually modify!
 * -------------------------------------------------------
 */
export var shadow = {
    '100': '0px 2px 8px 0px rgba(0, 0, 0, 0.06)',
    '200': '0px 0px 8px 0px rgba(0, 0, 0, 0.08)',
    '400': '0px 4px 8px 0px rgba(0, 0, 0, 0.2)',
    '800': '0px 6px 12px 0px rgba(0, 0, 0, 0.3)',
};
